import {
  composeGenericAppContextValue,
  GenericAppContextProvider,
  type GenericAppContextValue,
} from '@repo/internal-tools-app-lib/src/lib/GenericAppContext/GenericAppContext.tsx'
import { type ReactNode, useMemo } from 'react'
import {
  ENV_CCC_MAIN_BASE_PATH,
  ENV_INTERNAL_BFF_URL,
  ENV_INTERNAL_SIGNALR_URL,
} from '../../env.ts'

export type MainAppContextValue = GenericAppContextValue

export type MainAppContextProviderProps = Partial<MainAppContextValue> & {
  children?: ReactNode
}

export const MainAppContextProvider = (props: MainAppContextProviderProps) => {
  const { children, ...genericContextProps } = props

  // Memoize value depending on each value instead of the object reference.
  const genericContextValue = useMemo(
    () =>
      composeGenericAppContextValue({
        input: genericContextProps,
        defaultValues: {
          basePath: ENV_CCC_MAIN_BASE_PATH,
          baseApiUrl: ENV_INTERNAL_BFF_URL,
          baseSignalrUrl: ENV_INTERNAL_SIGNALR_URL,
        },
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    Object.values(genericContextProps),
  )

  return (
    <GenericAppContextProvider {...genericContextValue}>
      {children}
    </GenericAppContextProvider>
  )
}
